'use client';

import { useId, useState } from 'react';

// Passordfelt med «vis passord»-bryter. Bestilt 26.8.2026: uten den er det
// umulig å se om man har skrevet riktig, og folk låser seg ute av portalen på
// en skrivefeil de ikke kan oppdage.
//
// Tilgjengelighet: øyeknappen er en ekte <button type="button"> (ikke et ikon
// i en div), har aria-label og aria-pressed, og ligger UTENFOR tab-rekkefølgen
// til selve skjemaet er utfylt — den skal ikke stå mellom passord og «Logg inn».
type Props = {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
  required?: boolean;
  minLength?: number;
  autoComplete?: string;
  name?: string;
  id?: string;
};

export default function PasswordField({
  value,
  onChange,
  placeholder,
  className = '',
  required,
  minLength,
  autoComplete = 'current-password',
  name,
  id,
}: Props) {
  const [vis, setVis] = useState(false);
  const auto = useId();
  const feltId = id || auto;

  return (
    <div className="relative">
      <input
        id={feltId}
        name={name}
        type={vis ? 'text' : 'password'}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        required={required}
        minLength={minLength}
        autoComplete={autoComplete}
        className={`${className} pr-11`}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVis((v) => !v)}
        aria-label={vis ? 'Skjul passord' : 'Vis passord'}
        aria-pressed={vis}
        aria-controls={feltId}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-400 hover:text-stone-700 transition-colors p-1"
      >
        {vis ? (
          // Øye med strek over = skjul
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
            <line x1="1" y1="1" x2="23" y2="23" />
          </svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        )}
      </button>
    </div>
  );
}
